import { stepAssignedMeetingBodyLink } from './links.js';
import { seatApplicationWorkflowStepTypeValueLabels } from './value-labels.js';
export const seatApplicationWorkflowStepsCube = {
    category: 'Applications',
    description: 'Individual workflow steps with their order, type, and application counts.',
    label: 'Application Workflow Steps',
    requiredModule: 'hasTenure',
    measures: {
        'seat_application_workflow_steps.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'seat_application_workflow_steps.description': {
            label: 'Description',
            narrative: true,
            type: 'string',
        },
        'seat_application_workflow_steps.name': { label: 'Name', type: 'string' },
        'seat_application_workflow_steps.applications_at_step': {
            label: 'Applications At Step',
            type: 'number',
        },
        'seat_application_workflow_steps.order': { label: 'Order', type: 'number' },
        'seat_application_workflow_steps.type': {
            label: 'Type',
            type: 'string',
            valueLabels: seatApplicationWorkflowStepTypeValueLabels,
        },
        'seat_application_workflows.name': { label: 'Workflow', type: 'string' },
        'step_assigned_meeting_bodies.name': {
            label: 'Assigned Meeting Body',
            link: stepAssignedMeetingBodyLink,
            type: 'string',
        },
    },
    timeDimensions: {
        'seat_application_workflow_steps.created_at': { label: 'Created At', type: 'date' },
        'seat_application_workflow_steps.updated_at': { label: 'Updated At', type: 'date' },
    },
};
